export var formResetOnSuccess = {
  setup() {
    $(document).on('ajax:success', 'form[data-reset-on-success]', (event) => event.target.reset());
  }
};
